module.exports = __webpack_public_path__ + "img/voicemail.69f9d02d.svg";